import { useMemo } from 'react';
import * as yup from 'yup';
import FieldRepeaterCAreas from 'src/components/ui/FieldRepeater/connectors/FieldRepeaterCAreas';

export const useFormConnectedAreas = (params = {}) => {
	const { values, options = [], excludeIds = [] } = params;

	const initialValues = useMemo(() => {
		return {
			areas: [''],
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							repeater: {
								Component: FieldRepeaterCAreas,
								name: 'areas',
								options,
								excludeIds,
							},
						},
					],
				},
			],
		};
	}, [excludeIds, options]);

	const validationSchema = yup.object().shape({
		areas: yup.array().of(yup.object().required('Выберите площадку')),
	});

	return { shape, initialValues, validationSchema };
};
